import React from 'react';
import Image from 'next/image';
import { imageUrl } from 'theme';
import Button from 'app/seedly-component-library/button-new';

const ErrorCard = () => {
  return (
    <div className="card py-16">
      <div className="flex flex-col gap-4 w-full items-center">
        <Image src={imageUrl.errorBot} height={164} width={164} />
        <div className="flex flex-col  w-full items-center">
          <p className="text-sm font-bold text-center">
            Oops…something broke on our end
          </p>
          <p className="text-center">
            We aren’t able to fetch you the content right now. Try refreshing
            the page.
          </p>
        </div>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Refresh Page
        </Button>
      </div>
    </div>
  );
};

export default ErrorCard;
